import { useContext, useMemo, useState } from 'react'
import { ModalContext } from '../ModalContext'
import { XMarkIcon } from '@heroicons/react/24/outline'
import moment from 'moment'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function WorkoutConfigWeekdayAssignmentOverridesModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const workoutConfigsById = useMemo(() => {
        return new Map(
            (modalData.workoutConfigs ?? []).map((workoutConfig) => [
                workoutConfig.workoutConfigId,
                workoutConfig,
            ])
        )
    }, [modalData.workoutConfigs])

    const [workoutConfigWeekdayAssignmentOverrides, setWorkoutConfigWeekdayAssignmentOverrides] = useState(() => [...(modalData.workoutConfigWeekdayAssignmentOverridesJSON ?? [])])
    const [savingChanges, setSavingChanges] = useState(false)

    const sortedWorkoutConfigWeekdayAssignmentOverrides = [...workoutConfigWeekdayAssignmentOverrides].sort((a, b) => {
        if (a.date !== b.date) return a.date.localeCompare(b.date)
        const nameA = workoutConfigsById.get(a.workoutConfigId)?.name ?? ''
        const nameB = workoutConfigsById.get(b.workoutConfigId)?.name ?? ''
        return nameA.localeCompare(nameB)
    })

    const RemoveOverride = (overrideToRemove) => {
        setWorkoutConfigWeekdayAssignmentOverrides((prev) =>
            prev.filter((override) => override !== overrideToRemove)
        )
    }

    const OnSaveWorkoutConfigWeekdayAssignmentOverrides = async () => {
        setSavingChanges(true)
        await modalData.buttonAction(workoutConfigWeekdayAssignmentOverrides)
        setSavingChanges(false)
        HideModal()
    }

    return (
        <>
            <div className="text-center text-lg font-semibold leading-6 text-gray-900">
                Schedule Overrides
            </div>

            <div className="divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden">
                {sortedWorkoutConfigWeekdayAssignmentOverrides.length === 0 && (
                    <p className="px-3 py-3 text-xs text-center text-gray-400">
                        No overrides. Drag a workout on the calendar to another day in its week to add one
                    </p>
                )}

                {sortedWorkoutConfigWeekdayAssignmentOverrides.map((override) => (
                    <div
                        key={`${override.workoutConfigId}-${override.workoutVariantLetter}-${override.date}`}
                        className="flex items-center gap-x-4 px-3 py-3"
                    >
                        <p className="flex-1 text-sm text-left text-gray-900">
                            {workoutConfigsById.get(override.workoutConfigId)?.name ?? 'Unknown workout'} {override.workoutVariantLetter}
                        </p>

                        <p className="text-xs text-gray-500">
                            Moved to {moment(override.date, 'YYYY-MM-DD').format('ddd, MMM D YYYY')}
                        </p>

                        <button
                            type="button"
                            className="rounded p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                            onClick={() => RemoveOverride(override)}
                        >
                            <span className="sr-only">Remove</span>
                            <XMarkIcon className="h-3.5 w-3.5" aria-hidden="true" />
                        </button>
                    </div>
                ))}
            </div>

            <div className="pt-2">
                <BrandColorButton
                    text="Save"
                    action={OnSaveWorkoutConfigWeekdayAssignmentOverrides}
                    isLoading={savingChanges}
                />
            </div>
        </>
    )
}
